import React from 'react';
import {Image, Row, Col} from 'react-bootstrap';
import Helmet from "react-helmet";
import { Link } from 'react-router-dom';

import img1 from '../../assets/images/contents/ccis.png';

export const Proceeding = () => (
  <div>
  <Helmet>
    <title>The 7th International Conference on Soft Computing in Data Science 2022 (scds2023) - Proceeding</title>
    <meta name="description" content="The SCDS2015, SCDS2016, SCDS2017, SCDS2018 and SCDS2019 proceedings were published in the Communications 
      in Computer and Information Science series which is abstracted (indexed) by DBLP, EI, and Scopus." />
    <meta name="keywords" content="proceeding, scds 2022, uitm, aaec, shah alam, conference"/>
  </Helmet>
    <nav aria-label="breadcrumb" style={{ padding: '0.5rem'}}>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link to="/scds2023/home">Home</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Proceeding</li>
      </ol>
    </nav>


    <div className="items-center flex flex-wrap">
        <div className="w-full lg:w-6/12 px-2 ml-auto mr-auto text-center">
            <h1 color="dark">Proceeding</h1>
        </div>
    </div>

    <div style={{ textAlign:'justify', fontFamily: 'Verdana'}}>
      <p color="dark-200"  style={{ textAlign:'justify'}}>
        All accepted manuscripts will be published in the Communications in Computer and Information Science series, which is abstracted (indexed) by DBLP, EI, and Scopus and 
        will be submitted for inclusion in ISI Proceedings.<br/><br/>

        The SCDS2015, SCDS2016, SCDS2017, SCDS2018, SCDS2019 and SCDS2021  proceedings were published in the Communications in Computer and Information Science 
        series which is abstracted (indexed) by DBLP, EI, Scopus and were submitted for the inclusion in ISI Proceedings.<br/><br/> 
        
        <b>The previous proceedings links:</b><br/> 
        SCDS2015: <a href="http://www.springer.com/gp/book/9789812879356" target="blank">http://www.springer.com/gp/book/9789812879356</a><br/>  
        SCDS2016: <a href="http://www.springer.com/gp/book/9789811027765" target="blank">http://www.springer.com/gp/book/9789811027765</a><br/>
        SCDS2017: <a href="http://www.springer.com/gp/book/9789811072413" target="blank">http://www.springer.com/gp/book/9789811072413</a><br/> 
        SCDS2018: <a href="http://www.springer.com/gp/book/9789811334405" target="blank">http://www.springer.com/gp/book/9789811334405</a><br/>
        SCDS2019: <a href="https://link.springer.com/book/10.1007/978-981-15-0399-3" target="blank">https://link.springer.com/book/10.1007/978-981-15-0399-3</a><br/>
        SCDS2021: <a href="https://link.springer.com/book/10.1007/978-981-16-7334-4" target="blank">https://link.springer.com/book/10.1007/978-981-16-7334-4</a><br/>
      </p>
    </div>
    

  </div>
)